/**
 * Событие «сессия кончилась»: шлём его из clearClientSession, а слушает его
 * SessionWatcher в App и уводит кладовщика на ввод пин-кода. Без этого при 401
 * экран оставался открытым с ошибкой, и человек не понимал, что делать.
 */
export const CLIENT_SESSION_EXPIRED_EVENT = "client-session-expired";

const CLIENT_TOKEN_KEY = "client_token";
const CLIENT_USER_KEY = "client_user";
const CLIENT_SESSION_EXPIRES_AT_KEY = "client_session_expires_at";
const SESSION_TTL_MS = 30 * 24 * 60 * 60 * 1000;

function isExpired(expiresAtRaw) {
  const expiresAt = Number(expiresAtRaw);
  return !Number.isFinite(expiresAt) || expiresAt <= Date.now();
}

export function saveClientSession({ token, user }) {
  if (!token || !user) return;
  localStorage.setItem(CLIENT_TOKEN_KEY, token);
  localStorage.setItem(CLIENT_USER_KEY, JSON.stringify(user));
  localStorage.setItem(
    CLIENT_SESSION_EXPIRES_AT_KEY,
    String(Date.now() + SESSION_TTL_MS),
  );
}

export function clearClientSession() {
  const had = Boolean(localStorage.getItem(CLIENT_TOKEN_KEY));
  localStorage.removeItem(CLIENT_TOKEN_KEY);
  localStorage.removeItem(CLIENT_USER_KEY);
  localStorage.removeItem(CLIENT_SESSION_EXPIRES_AT_KEY);
  // Сообщаем только если сессия действительно была: иначе на экране входа
  // каждый фоновый запрос слал бы лишнее событие.
  if (had && typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(CLIENT_SESSION_EXPIRED_EVENT));
  }
}

/** Есть ли ещё живая сессия (токен не истёк по локальному сроку). */
export function hasClientSession() {
  const expiresAtRaw = localStorage.getItem(CLIENT_SESSION_EXPIRES_AT_KEY);
  if (isExpired(expiresAtRaw)) return false;
  return Boolean(localStorage.getItem(CLIENT_TOKEN_KEY));
}

export function getClientUser() {
  const expiresAtRaw = localStorage.getItem(CLIENT_SESSION_EXPIRES_AT_KEY);
  if (isExpired(expiresAtRaw)) {
    clearClientSession();
    return null;
  }
  const raw = localStorage.getItem(CLIENT_USER_KEY);
  return JSON.parse(raw || "null");
}

export function getClientToken() {
  const expiresAtRaw = localStorage.getItem(CLIENT_SESSION_EXPIRES_AT_KEY);
  if (isExpired(expiresAtRaw)) {
    clearClientSession();
    return null;
  }
  return localStorage.getItem(CLIENT_TOKEN_KEY);
}
